'use client';

import { AppProgressBar } from 'next-nprogress-bar';

export const ProgressBar = ({ children }) => {
    return (
        <>
            <AppProgressBar
                height="4px"
                color="rgb(221, 34, 34)"
            />
            {children}
        </>
    );
};